import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="container mx-auto p-6 max-w-4xl text-gray-800">
      <h1 className="text-3xl font-semibold mb-4">Privacy Policy</h1>

      <p className="mb-4">
        This Privacy Policy explains how we collect, use, store, and protect
        information when organizations use our cloud-based platform for hospital
        management, human resources, and related business operations.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>
          Organization and user registration details such as name, email, and
          contact number.
        </li>
        <li>
          Employee and patient data entered by authorized users of the
          organization.
        </li>
        <li>
          Billing and payment information processed through trusted third-party
          gateways (e.g., Razorpay or Stripe).
        </li>
        <li>
          System logs, usage metrics, and technical data for improving platform
          performance and security.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        2. Purpose of Data Usage
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>
          To provide secure access to hospital and HR management features.
        </li>
        <li>To process subscriptions, renewals, and invoices.</li>
        <li>
          To deliver customer support and notify users about system updates.
        </li>
        <li>
          To comply with applicable healthcare, tax, and data protection laws.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        3. No Sale or Commercial Use of Data
      </h2>
      <p className="mb-4">
        We <strong>do not sell, rent, trade, or share</strong> any patient,
        employee, or organizational data with third parties for marketing,
        analytics, or commercial gain. All data entered into the system remains
        strictly owned by the respective organization.
      </p>
      <p className="mb-4">
        We act solely as a <strong>data processor</strong> — facilitating secure
        data storage and access as per the client’s instructions. Under no
        circumstances will patient or employee data be used for profiling,
        advertising, or external analysis.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Security</h2>
      <p className="mb-4">
        All data transfers are encrypted using industry-standard SSL/TLS
        protocols. Information is stored on secure servers with restricted
        access. Regular security audits and compliance checks are conducted to
        ensure data integrity.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        5. Third-Party Services
      </h2>
      <p className="mb-4">
        We rely on verified third-party providers for payment processing,
        hosting, and analytics. These providers are obligated to handle all
        information according to their respective privacy and security policies
        and are compliant with relevant data protection laws.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Data Retention</h2>
      <p className="mb-4">
        Data is retained only for as long as necessary to fulfill contractual or
        legal obligations. Upon termination of the client account, all
        organizational data may be deleted or archived as per the client’s
        written instructions.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. User Rights</h2>
      <p className="mb-4">
        Organizations and users may request access, correction, or deletion of
        their personal or institutional data by contacting{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        .
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        8. Compliance with Data Protection Laws
      </h2>
      <p className="mb-4">
        The Platform complies with applicable data protection laws including the{" "}
        <strong>
          Digital Personal Data Protection Act (DPDP) of India, 2023
        </strong>
        , <strong>GDPR</strong> (for EU users), and <strong>HIPAA</strong> (for
        healthcare data handling).
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        9. Updates to this Policy
      </h2>
      <p className="mb-4">
        This Privacy Policy may be updated periodically to reflect changes in
        regulations, technology, or business practices. The latest version will
        always be available on this page, with a revised effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">10. Contact</h2>
      <p>
        For any privacy-related questions or concerns, please contact{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        .
      </p>
    </div>
  );
}
